import { ProcessContent } from '@core/services/site-content/site-content.types';
import { Component, css, html, LitElement, property } from '@rxdi/lit-html';
import { rich } from '@shared/rich-text';
import { StudioStyles } from '@shared/styles/studio.styles';

/** Home: how a project runs. */
@Component({
  selector: 'rs-process',
  styles: [
    StudioStyles,
    css`
      .track {
        position: relative;
        display: grid;
        gap: 18px;
        list-style: none;
        margin: 0;
        padding: 0;
      }

      @media (min-width: 960px) {
        .track {
          grid-template-columns: repeat(4, 1fr);
          gap: 18px;
        }
        .track::before {
          content: '';
          position: absolute;
          top: 27px;
          left: 28px;
          right: 28px;
          height: 1px;
          background: linear-gradient(90deg, var(--rs-signal), var(--rs-ion), var(--rs-plasma));
          opacity: 0.6;
        }
      }

      .step {
        position: relative;
      }

      .dot {
        position: relative;
        z-index: 1;
        display: grid;
        place-items: center;
        width: 56px;
        height: 56px;
        border-radius: 50%;
        border: 1px solid var(--rs-line-strong);
        background: var(--rs-ink);
        font-family: var(--rs-font-mono);
        font-size: 13px;
        color: var(--rs-signal);
        transition: background 0.3s var(--rs-ease), color 0.3s var(--rs-ease);
      }

      .step:hover .dot {
        background: var(--rs-signal);
        color: var(--rs-text-on-accent);
      }

      .op {
        display: block;
        margin-top: 22px;
        font-family: var(--rs-font-mono);
        font-size: 13px;
        color: var(--rs-text-muted);
      }

      h3 {
        margin: 6px 0 10px;
        font-family: var(--rs-font-display);
        font-size: 26px;
        letter-spacing: -0.03em;
      }

      p {
        margin: 0;
        color: var(--rs-text-2);
        line-height: 1.6;
      }
    `,
  ],
  template(this: ProcessComponent) {
    const c = this.content;
    if (!c) {
      return html``;
    }
    return html`
      <section class="section" id="process">
        <div class="wrap">
          <div class="section-head">
            <span class="kicker"><span class="index">04</span> How we work</span>
            <h2 class="h2">${rich(c.heading)}</h2>
          </div>
          <ol class="track">
            ${c.steps.map(
              (s, i) => html`
                <li class="step">
                  <span class="dot">0${i + 1}</span>
                  <span class="op">.pipe(${s.op})</span>
                  <h3>${s.title}</h3>
                  <p>${s.body}</p>
                </li>
              `
            )}
          </ol>
        </div>
      </section>
    `;
  },
})
export class ProcessComponent extends LitElement {
  @property({ attribute: false }) content: ProcessContent;
}
